import React, {Component} from 'react'
import PropTypes from 'prop-types'

const _MAX_TYPES = 3

class BaskItemTypes extends Component {
    _parseTypes = () => {
        const {types} = this.props
        const vTypes = Array.isArray(types) ? types : []

        if (!vTypes.length) return ''

        if (vTypes.length <= _MAX_TYPES) {
            return vTypes.join(', ')
        }

        const begin = vTypes.slice(0, _MAX_TYPES)
        begin.push('...')

        return begin.join(', ')
    }

    render() {
        const types = this._parseTypes()

        return (
            <td className='BaskItemTypes'>
                {types}
            </td>
        )
    }
}

BaskItemTypes.propTypes = {
    types: PropTypes.array,
}

export default BaskItemTypes
